export default __webpack_public_path__ + "static/media/warranty.55a6238c.svg";